import React from "react";
import { useTranslation } from "react-i18next";
import { RiImageAddFill } from "react-icons/ri";
import { FiEdit, FiTrash2 } from "react-icons/fi";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { Button, Col, Row } from "react-bootstrap";
import { DropZone, EditModal } from "../../index";
import { useScreenSize } from "../../../utils";
import { useAppContext } from "../../../context";
import style from "./MobileTopBarCommands.module.css";

const MobileTopBarCommands = ({
  goToPrev,
  goToNext,
  handleDeleteImage,
  editCanvasModal,
  setEditCanvasModal,
  handleBrightnessChange,
}) => {
  const { state } = useAppContext();
  const screenSize = useScreenSize();
  const { t } = useTranslation();

  return (
    <Row className={style.mobileTopBarCommandsContainer}>
      <Col>
        <div className={`text-center ${style.mobileTopBarAddBtn}`}>
          <RiImageAddFill size="1.2rem" />
          <DropZone addTopBarMobile={true} />
        </div>
      </Col>
      {state.images.length > 1 && screenSize <= 992 && (
        <Col className={`p-0 ${style.prevNextContainer}`}>
          <Button
            variant="dark"
            onClick={goToPrev}
            disabled={state.index === 0}
            size="sm"
            className={style.mobileTopBarCommandsBtn}
          >
            <FaArrowLeft />
          </Button>
          {`${state.index + 1}/${state.images.length}`}
          <Button
            variant="dark"
            onClick={goToNext}
            disabled={state.images.length - 1 === state.index}
            size="sm"
            className={style.mobileTopBarCommandsBtn}
          >
            <FaArrowRight />
          </Button>
        </Col>
      )}
      <Col>
        <div className="text-center">
          <Button
            onClick={handleDeleteImage}
            disabled={state.images.length > 0 ? false : true}
            className={style.mobileTopBarCommandsBtn}
          >
            <FiTrash2 size="1.2rem" />
            <div>{t("Delete")}</div>
          </Button>
        </div>
      </Col>
      <Col>
        <div className="text-center">
          <Button
            variant="dark"
            size="sm"
            className={style.mobileTopBarCommandsBtn}
            disabled={state.images.length > 0 ? false : true}
            onClick={() => setEditCanvasModal(true)}
          >
            <FiEdit  size="1.2rem" />
            <div>{t("Edit")}</div>
          </Button>
        </div>
      </Col>
      <EditModal
        editCanvasModal={editCanvasModal}
        setEditCanvasModal={setEditCanvasModal}
        handleBrightnessChange={handleBrightnessChange}
      />
    </Row>
  );
};

export default MobileTopBarCommands;
